import './App.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Page404 from './pages/404';
import Planning from './pages/Planning';
import Documents from './pages/Documents';
import Meetings from './pages/Meetings';
import Contact from './pages/Contact';

function App() {

  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/NotFound" element={<Page404 />} />
          <Route path='/Planning' element={<Planning />} />
          <Route path='/Documents' element={<Documents />} key={Math.random()} keyProp={1234}/>
          <Route path='/Meetings' element={<Meetings />} key={Math.random()} keyProp={1234} />
          <Route path='/Contact' element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter >
  );
}

export default App;